import pic1 from "../images/blog/blogHero/sleep.jpg";
import pic2 from "../images/blog/blogHero/brain.jpg";
import pic3 from "../images/blog/blogHero/food.jpg";
import pic4 from "../images/blog/blogHero/plan.jpg";
import pic5 from "../images/blog/blogHero/play.jpg";
import pic6 from "../images/blog/blogHero/reading.jpg";
import pic7 from "../images/blog/blogHero/motherReading.jpg";
import pic8 from "../images/blog/blogHero/familyPlaying.jpg";
import pic9 from "../images/blog/blogHero/parenting.jpg";
import pic10 from "../images/blog/blogHero/author.jpg";
import pic11 from "../images/blog/blogHero/eleven.jpg";
import pic12 from "../images/blog/blogHero/twelve.jpg";
import pic13 from "../images/blog/blogHero/thirteen.jpg";
import pic14 from "../images/blog/blogHero/fourteen.jpg";
import image7 from "../images/blog/NewBlog1/image7.png";
import thumb14 from "../images/blog/NewBlog2/image16.png";
import thumb15 from "../images/blog/NewBlog3/image3.png";
import thumb16 from "../images/blog/NewBlog4/image2.png";
import thumb17 from "../images/blog/NewBlog5/image20.png";
import thumb18 from "../images/blog/NewBlog6/image14.png";
// import aPramitha from "../images/blog/blogAuthor/pramitha.png";
import aMiruthula from "../images/blog/blogAuthor/m.jpg";
import aAlagu from "../images/blog/blogAuthor/aAlagu.jpg";
import niharika from "../images/blog/blogAuthor/niharika.png";
import prahalad from "../images/blog/blogAuthor/prahalad.jpeg";
import srilakshmi from "../images/blog/blogAuthor/srilakshmi.jpg";
import Pramitha from "../images/blog/blogAuthor/new.jpg";

// import pic9 from "../../../images/blog/blogHero/sleep.jpg"

const BlogContent = [
  {
    //done
    id: 1,
    h1: "Nurturing a Lifelong Love for Reading in Children: Embracing Neurodiversity",
    blogImg: pic7,
    des: "In a world inundated with screens and distractions, cultivating a passion for reading in children has become more important than ever. The journey towards creating avid readers begins at a young age and is intricately connected to each child's unique neurodivergence. Understanding the relationship between reading habits and neurodiversity is crucial for parents and caregivers. By acknowledging common patterns and addressing them appropriately, we can pave the way for a fulfilling reading experience that caters to every child's individuality.",
    author: "Niharika",
    gender: "female",
    img: niharika,
  },
  {
    id: 2,
    h1: "The Crucial Role of Parental Engagement in Early Years: Nurturing Neurodivergent Potential.",
    blogImg: pic8,
    des: "In the fascinating journey of parenthood, there is a remarkable phase that lays the foundation for a child's future: the early years. These formative years are akin to the first strokes on a canvas, shaping the intricate patterns of a child's life. Parental engagement during this period is not just beneficial but pivotal, especially when considering the context of neurodivergence. Neurodivergence, with its array of unique patterns and potentials, adds an extra layer of significance to the role of parents in a child's early development. Let's delve into the reasons why parental engagement is critical in these early years and explore the connection between nurturing developmental milestones and paving the path for future success.",
    author: "prahalad",
    gender: "male",
    img: prahalad,
  },
  {
    //done
    id: 3,
    h1: "Tantrums Tears and Tempers:Behaviour is communication",
    blogImg: pic10,
    des: "A child in a store aisle, stomping their feet, face red and screaming loudly. People nearby give disapproving looks, parents feel embarrassed, and dealing with the child's frustration seems really hard. But under all these strong feelings, there's an important truth: behavior is a way of talking. This becomes even clearer when we think about neurodivergence – that's when people's brains work in different ways, like with autism or ADHD.",
    author: "prahalad",
    gender: "male",
    img: prahalad,
  },
  // {
  //   //done
  //   id: 4,
  //   h1: "DEVELOPMENT MILESTONES:CELEBRATION OR CHECKLIST?",
  //   blogImg: pic4,
  //   des: "Have you witnessed grandparents excitedly sharing sweet treats to celebrate their grandchild’s grand achievement—turning over for the first time? Did your heart skip a beat when your little one said their first magical words or took their first wobbly steps? These momentous landmarks are expressions of your child’s ongoing learning and development since the moment of birth. While these developmental milestones are surely moments to celebrate for reasons other than scrumptious sweets, they can also be crucial identifiers of your child’s development or, in some cases, a call for support.",
  //   author: "Srilakshmi",
  //   gender: "female",
  //   img: srilakshmi,
  // },
  {
    //done
    id: 4,
    h1: "The Power Of Play",
    blogImg: pic5,
    des: "Play is a child's special moment. Play is a precious gift to children allowing them to cultivate skills needed for their bright future. For children, play is essential for their growth, learning, development, and general well-being. They use play as a basic and natural method to freely express themselves, learn new abilities, and make sense of the environment. To them play is more than simply a pastime.",
    author: "Miridula",
    gender: "female",
    img: aMiruthula,
  },
  // {
  //   //done
  //   id: 6,
  //   h1: "The Crucial Role of Parental Engagement in Early Years: Nurturing Neurodivergent Potential",
  //   blogImg: pic9,
  //   des: "In the fascinating journey of parenthood, there is a remarkable phase that lays the foundation for a child's future: the early years. These formative years are akin to the first strokes on a canvas, shaping the intricate patterns of a child's life. Parental engagement during this period is not just beneficial but pivotal, especially when considering the context of neurodivergence. Neurodivergence, with its array of unique patterns and potentials, adds an extra layer of significance to the role of parents in a child's early development. Let's delve into the reasons why parental engagement is critical in these early years and explore the connection between nurturing developmental milestones and paving the path for future success.",
  //   author: "prahalad",
  //   gender: "male",
  //   img: prahalad,
  // },
  {
    //done
    id: 5,
    h1: "Nurturing reading habits in children",
    blogImg: pic6,
    des: "In a world taken over by technologies, having a balance is crucial for a healthy life. Especially the balance between technology and reading. As times change, children’s interests change, but if they are exposed to good habits like reading, they would have a good start to a balance with technology.",
    author: "Alagu",
    gender: "male",
    img: aAlagu,
  },
  {
    //done
    id: 6,
    h1: "Gut-Brain Connection",
    blogImg: pic2,
    des: "Why is the gut known as our second brain? We have more neurotransmitters in the gut than the entire body. And even serotonin is produced in the guts. Improper care can cause an imbalance in serotonin and other neurotransmitters which in turn, significantly impacts mood, sleep and behaviours.",
    author: "Alagu",
    gender: "male",
    img: aAlagu,
  },
  {
    //done
    id: 7,
    h1: "Recognizing the power of sleep for neurodivergent children and its impact on milestone achievement",
    blogImg: pic1,
    des: "Beyond the textbooks and playground adventures, there's an untapped secret that holds the power to supercharge your child's potential. while we tirelessly champion their growth, let's not forget the unsung hero: sleep. brace yourself to uncover the awe-inspiring connection between rest and reaching milestones, ensuring unstoppable emotional well-being, robust development, and soaring academic triumph",
    author: "Prahalad",
    gender: "male",
    img: prahalad,
  },
  {
    //done
    id: 8,
    h1: "FOOD AFFECTS NEURODIVERGENCE!!",
    blogImg: pic3,
    des: "The connection between them is not one that can be easily made but it should be one that needs to be acknowledged by parents and adults. We must understand that for children with Neurodiversity children, numerous eating difficulties can exist. It is of utmost importance that children with Neurodiversity develop healthy eating habits. It is the responsibility of parents and caregivers to pay attention to dietary sensitivities, food aversions, allergies, and intolerances.",
    author: "Miridula",
    gender: "female",
    img: aMiruthula,
  },
  {
    //done
    id: 9,
    h1: "Role of Environment in the Communication of Children on the Autism Spectrum",
    blogImg: pic11,
    des: "One of the most crucial aspects of socialization that young children diagnosed with Autism Spectrum Disorder (ASD) struggle with is coherent communication, and expressing their feelings in a manner that is comprehensible to those around them. ",
    author: "Pramitha Sivaprakash",
    gender: "female",
    img: Pramitha,
  },
  {
    //done
    id: 10,
    h1: "How much screen time is too much for a child's brain and its relevance to Adhd and Autism?",
    blogImg: pic12,
    des: "“Screen time” is a term used for activities done in front of any screen such as televisions, computers, I-pads or even video games. “Screen time is a sedentary activity meaning you are being physically inactive while sitting down. Very little energy is used during screen time”",
    author: "Niharika",
    gender: "female",
    img: niharika,
  },
  //blog 12
  // https://drive.google.com/file/d/18WRkRdJ7eYGqfgXzWvhA83DaFrQV6EEx/view?ts=66b0d198&pli=1

  {
    //done
    id: 11,
    h1: "LETTING LEARNING FLOURISH",
    blogImg: pic13,
    des: "The key to understanding this is to acknowledge everyone needs support and help. As one of my facilitators at ELiNA put it- It is not a suggestion its a right of every student to recieve help and enthusiastic support from their teachers, parents and mentors. You might have been told from previous experiences that help or customised aid is preventing children from growing or learning the harshness of the real world but this couldn't be farther from the truth!",
    author: "Niharika",
    gender: "female",
    img: niharika,
  },
  //blog 13
  // https://drive.google.com/file/d/15C4D83aXysDizQN2TIL4rhrim55f0689/view?ts=66b0d21f
  {
    //done
    id: 12,
    h1: "Equity In Education",
    blogImg: pic14,
    des: "The key to understanding this is to acknowledge everyone needs support and help. As one of my facilitators at ELiNA put it- It is not a suggestion its a right of every student to recieve help and enthusiastic support from their teachers, parents and mentors. You might have been told from previous experiences that help or customised aid is preventing children from growing or learning the harshness of the real world but this couldn't be farther from the truth!",
    author: "Niharika",
    gender: "female",
    img: niharika,
  },
  // {
  //   id: 13,
  //   h1: "My Child Is Smart — So Why Is School So Hard",
  //   blogImg: image7, // Using image7 as a dummy image for now
  //   des: "Many parents ask this question with confusion and disbelief. “My child understands things so well… so why is school such a struggle?” They see sharp observation, strong memory, curiosity, and creativity. Conversations at home are rich. Ideas flow easily. Yet report cards, notebooks, and classroom feedback tell a very different story.",
  //   author: "Niharika", // Assuming same author as other recent ones
  //   gender: "female",
  //   img: niharika,
  // },
  // {
  //   id: 14,
  //   h1: "When Effort Looks Like Avoidance",
  //   blogImg: thumb14,
  //   des: "Your child can do the work, but avoids starting. Learn why hesitation is often mistaken for avoidance—and how safety brings effort back.",
  //   author: "Niharika",
  //   gender: "female",
  //   img: niharika,
  // },
  // {
  //   id: 15,
  //   h1: "The Child Who Can Focus for Hours — But Only on Certain Things",
  //   blogImg: thumb15,
  //   des: "Your child can focus deeply on games or art but not schoolwork? Learn why focus is selective, not absent—and how interest fuels attention.",
  //   author: "Niharika",
  //   gender: "female",
  //   img: niharika,
  // },
  // {
  //   id: 16,
  //   h1: "Why Constant Reminding Slowly Breaks Independence",
  //   blogImg: thumb16,
  //   des: "Constant reminders feel helpful, but over time they reduce independence. Learn how stepping back builds confidence and self-reliance in children.",
  //   author: "Niharika",
  //   gender: "female",
  //   img: niharika,
  // },
  // {
  //   id: 17,
  //   h1: "Routine vs Relationship: What Actually Holds a Child Together?",
  //   blogImg: thumb17,
  //   des: "Torn between routines and connection? Learn why relationship—not control—is the foundation that helps children cooperate and try again.",
  //   author: "Niharika",
  //   gender: "female",
  //   img: niharika,
  // },
  // {
  //   id: 18,
  //   h1: "Not Every Child Is Meant to “Fit In” the Same Way",
  //   blogImg: thumb18,
  //   des: "Worried your child doesn't fit the system? Learn why success isn't uniform—and how redefining growth creates space for confidence and wellbeing.",
  //   author: "Niharika",
  //   gender: "female",
  //   img: niharika,
  // },
];

export default BlogContent;
